import _ from 'lodash';

export default function CustomListItemFormColumns(customListItem, data) {
  return [
    ['list_with_image', 'image'].includes(data.kind) && {
      prop: 'image',
      label: this.$t('customListItem.image'),
      renderCell: {
        component: 'upload',
        required: data.cn === 'CustomList',
      }
    },
    data.kind === 'video_list' && {
      prop: 'video',
      label: this.$t('customListItem.video'),
      renderCell: {
        component: 'upload',
        required: true,
        props: {
          accept: 'video/*',
          type: 'video',
          size: 500, // 500 MB
        }
      }
    },
    data.kind === 'video_list' && {
      prop: 'video_cover',
      label: this.$t('customListItem.videoCover'),
      renderCell: {
        component: 'upload',
        required: true,
      }
    },
    ['list_with_image', 'image'].includes(data.kind) && {
      prop: 'target_type',
      label: this.$t('customListItem.targetType'),
      renderCell: {
        component: 'select',
        props: {
          clearable: true,
          options: [
            { label: this.$t('model.merchant'), value: 'Merchant' },
            { label: this.$t('model.ticketEvent'), value: 'TicketEvent' },
            { label: this.$t('customListItem.externalLink'), value: 'Link::External' },
          ],
        }
      }
    },
    customListItem.target_type === 'Merchant' && (data.cn !== 'CustomList' || this.merchantList) && {
      prop: 'merchant_id',
      label: this.$t('model.merchant'),
      renderCell: {
        component: 'select',
        required: true,
        props: {
          filterable: true,
          xRemotePreload: async () => {
            if (data.cn === 'CustomList') {
              return this.merchantList.map(({ id, name }) => ({ label: name, value: id }));
            } else {
              const merchants = await this.$request.get('/merchants/read_options', { per_page: 999 })
              return _.map(merchants.data, ({ id, name }) => ({ value: id, label: name }))
            }
          },
          xRemoteSearch: async (keyword) => {
            const { data } = await this.$request.get('/merchants/read_options', { keyword })
            return _.map(data, ({ id, name }) => ({ value: id, label: name }))
          },
        },
        domProps: {
          style: 'width: 100%'
        }
      }
    },
    customListItem.target_type === 'TicketEvent' && (data.cn !== 'CustomList' || this.ticketEventList) && {
      prop: 'ticket_event_id',
      label: this.$t('model.ticketEvent'),
      renderCell: {
        component: 'select',
        required: true,
        props: {
          filterable: true,
          xRemotePreload: async () => {
            if (data.cn === 'CustomList') {
              return this.ticketEventList.map(({ id, title }) => ({ label: title, value: id }))
            } else {
              const ticketEvents = await this.$request.get('/ticket_events/read_options', { per_page: 999 })
              return _.map(ticketEvents.data, ({ id, title }) => ({ value: id, label: title }))
            }
          },
          xRemoteSearch: async (keyword) => {
            const { data } = await this.$request.get('/ticket_events/read_options', { keyword })
            return _.map(data, ({ id, title }) => ({ value: id, label: title }))
          },
        },
        domProps: {
          style: 'width: 100%'
        }
      }
    },
    customListItem.target_type === 'Link::External' && {
      prop: 'external_link',
      label: this.$t('customListItem.externalLink'),
      renderCell: {
        component: 'input',
        required: true,
      }
    }
  ].filter(Boolean)
}
